module.exports = __webpack_public_path__ + "img/1497441201.5b8ce2fb.jpg";